import { useMutation } from '@tanstack/react-query';
import { ChainId } from '@shared/utils/config/networks';
import { getUrls } from '@shared/utils/config/environment';
import { determineVMType } from '@shared/utils/validation/network-validation';
import { determineOrderString } from '@shared/utils/validation/order-validation';
import useGetWrappedWallet from '../auth/useGetWrappedWallet';
import { useSession } from '@/contexts/LitSessionProvider';
import { executeOrderWrapper } from '@/lib/executorHelpers/executeOrder/executeOrderWrapper';
const useWithdrawAsset = ({
  transferParams,
  quoteParams
}) => {
  const {
    PKP,
    litSession
  } = useSession();
  const {
    getEVMWallet,
    getSolanaWallet,
    getSuiWallet
  } = useGetWrappedWallet();
  // mutation for withdraw funds
  const {
    data: mutateWithdrawOrderData,
    mutate: mutateWithdrawOrder,
    isPending: isPendingMutateWithdrawOrder,
    isSuccess: isSuccessMutateWithdrawOrder,
    error: onErrorMutateWithdrawOrder
  } = useMutation({
    mutationFn: async () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      if (!transferParams || !quoteParams) throw new Error('mutateWithdrawOrder:error on params.');
      const network = transferParams === null || transferParams === void 0 ? void 0 : transferParams.network;
      const vmType = determineVMType(network);
      const isSponsored = ((_a = quoteParams === null || quoteParams === void 0 ? void 0 : quoteParams.fees) === null || _a === void 0 ? void 0 : _a.sponsorUsd) > 0;
      const orderType = determineOrderString('WITHDRAW', vmType, isSponsored);
      try {
        const _executeOrderParams = {
          params: quoteParams,
          sessionSigs: litSession,
          pkp: Object.assign({}, PKP),
          cloudWallet: PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
          orderType,
          transferParams,
          keypair: await getSolanaWallet(),
          signer: await getEVMWallet()
          // suiWallet: await getSuiWallet(),
        };
        const _executeOrder = await executeOrderWrapper(Object.assign({}, _executeOrderParams));
        const token = transferParams === null || transferParams === void 0 ? void 0 : transferParams.token_address;
        const network = transferParams === null || transferParams === void 0 ? void 0 : transferParams.network;
        const from_address = network == ChainId.SOLANA ? transferParams === null || transferParams === void 0 ? void 0 : transferParams.from_address : (_b = transferParams === null || transferParams === void 0 ? void 0 : transferParams.from_address) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        const to_address = network == ChainId.SOLANA ? transferParams === null || transferParams === void 0 ? void 0 : transferParams.to_address : (_c = transferParams === null || transferParams === void 0 ? void 0 : transferParams.to_address) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        const txHash = (_f = (_e = (_d = _executeOrder === null || _executeOrder === void 0 ? void 0 : _executeOrder.result) === null || _d === void 0 ? void 0 : _d.decodedResponse) === null || _e === void 0 ? void 0 : _e.transferTransaction) === null || _f === void 0 ? void 0 : _f.hash;
        const updateFromUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${network}&wallet=${from_address}&token=${token}&tx_hash=${txHash}`;
        const updateToUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${network}&wallet=${to_address}&token=${token}&tx_hash=${txHash}`;
        const updateNativeFromUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${network}&wallet=${from_address}&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tx_hash=${txHash}`;
        const updateNativeToUrl = `${getUrls().INDEXER_URL}/jobs/index-balance-for-token?chain=${network}&wallet=${to_address}&token=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tx_hash=${txHash}`;
        fetch(updateFromUrl);
        fetch(updateToUrl);
        fetch(updateNativeFromUrl);
        fetch(updateNativeToUrl);
        if (((_h = (_g = _executeOrder === null || _executeOrder === void 0 ? void 0 : _executeOrder.result) === null || _g === void 0 ? void 0 : _g.decodedResponse) === null || _h === void 0 ? void 0 : _h.status) != 'success') {
          throw new Error(((_k = (_j = _executeOrder === null || _executeOrder === void 0 ? void 0 : _executeOrder.result) === null || _j === void 0 ? void 0 : _j.decodedResponse) === null || _k === void 0 ? void 0 : _k.error) || 'Withdraw failed!');
        }
        return Promise.resolve({
          data: _executeOrder
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    onSuccess: data => {
      console.log('mutateWithdrawOrder:SUCCESS', {
        data
      });
    },
    onError: e => {
      console.error('mutateWithdrawOrder:ERROR', e);
    }
  });
  return {
    mutateWithdrawOrderData,
    mutateWithdrawOrder,
    isPendingMutateWithdrawOrder,
    isSuccessMutateWithdrawOrder,
    onErrorMutateWithdrawOrder
  };
};
export default useWithdrawAsset;